export default "__VITE_ASSET__DIRTR93b__"